// const temp = require('@electron/remote').process.argv;

export default function () {
  return process.env.NODE_ENV === "development";
  // return temp[2] == '--dev';
}
